import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import {
  deleteWork,
  fetchWorks,
  updateWork
} from '../../../../../../../stores/works/works.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import {
  getPagination,
  getWork
} from '../../../../../../../stores/works/works.selectors'
import { getPupil } from '../../../../../../../stores/pupil/pupil.selectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { id }) => {
  const work = getWork(state, id)
  const pupil = getPupil(state)
  return {
    status: work.status,
    pagination: getPagination(state),
    canPublish: !!pupil && pupil.account.student_type.policy.can_publish
  }
}

const mapDispatchToProps = (dispatch, { id }) => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onPublish: () =>
    dispatch(updateWork(ownProps.id, { state: 'published' })).catch(
      errorHandler
    ),
  onUnpublish: () =>
    dispatch(updateWork(ownProps.id, { state: 'evidence_bank' })).catch(
      errorHandler
    ),
  onDelete: () =>
    dispatch(deleteWork(ownProps.id))
      .then(() =>
        dispatch(
          fetchWorks(ownProps.match.params.id, {
            page: stateProps.pagination.current
          })
        )
      )
      .catch(errorHandler)
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(ContextMenu)
)
